// Load environment variables based on NODE_ENV
const getEnvFile = () => {
  const env = process.env.NODE_ENV || 'development';
  
  // Map NODE_ENV to .env file suffix
  const envMap: Record<string, string> = {
    development: '.local',
    staging: '.stage',
    production: '.prod',
  };

  const suffix = envMap[env] || '.local';
  
  // In Create React App, environment variables are loaded from .env files
  // We'll use REACT_APP_ prefix for all variables
  return suffix;
};

// Export environment configuration
export const envConfig = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api',
  
  // App Configuration
  APP_NAME: process.env.REACT_APP_APP_NAME || 'OMECAP HUB',
  APP_VERSION: process.env.REACT_APP_APP_VERSION || '1.0.0',
  
  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',
  ENV_SUFFIX: getEnvFile(),
  
  // Feature Flags
  ENABLE_DEBUG: process.env.REACT_APP_ENABLE_DEBUG === 'true',

  /**
   * Dùng dữ liệu mẫu cho hóa đơn (mock/invoices.ts), không gọi API — tiện test UI.
   * - `true`: luôn mock
   * - `false`: luôn gọi API
   * - không set: development → mock, production → API
   */
  USE_INVOICE_MOCK: (() => {
    const v = process.env.REACT_APP_USE_INVOICE_MOCK;
    if (v === 'true') return true;
    if (v === 'false') return false;
    return process.env.NODE_ENV === 'development';
  })(),

  /** Thống kê hóa đơn — mock/mock/statistics.ts khi bật */
  USE_STATISTICS_MOCK: (() => {
    const v = process.env.REACT_APP_USE_STATISTICS_MOCK;
    if (v === 'true') return true;
    if (v === 'false') return false;
    return process.env.NODE_ENV === 'development';
  })(),
};

// Log environment info in development
if (process.env.NODE_ENV === 'development') {
  console.log('Environment Configuration:', {
    NODE_ENV: envConfig.NODE_ENV,
    ENV_SUFFIX: envConfig.ENV_SUFFIX,
    API_BASE_URL: envConfig.API_BASE_URL,
    USE_INVOICE_MOCK: envConfig.USE_INVOICE_MOCK,
    USE_STATISTICS_MOCK: envConfig.USE_STATISTICS_MOCK,
  });
}

export default envConfig;

